import {
  Button,
  Input,
  Stack,
  Grid,
  Box,
  Center,
  Checkbox,
  FormLabel,
  Flex,
  Spinner,
  InputGroup,
  Select,
  Heading,
  InputRightElement,
  Text,
  Image,
  useColorModeValue,
  Link,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import arrow from "../assets/arrow.svg";
import logo from "../assets/logo.png";
import { useNavigate } from "react-router-dom";
import { BsEye, BsEyeSlash } from "react-icons/bs";
import { FaRegTimesCircle } from "react-icons/fa";
import { successNotifier } from "..";
import { resetPassword } from "../components/signupSteps/service";
import { BASE_COLOR } from "../constants";
import { useGetState } from "../context/useGetState";
import splash from "../assets/splash.jpg";
function ResetPassword() {
const navigate = useNavigate();
  const textColor = useColorModeValue("#fff", "#fff");
  const [formValues, setFormValues] = useState({});
  const [loading, setLoading] = useState(false);
  const [disabled, setDisabled] = useState(true);
  const { state, dispatch } = useGetState();
  const [show, setShow] = useState(false);
  const [show2, setShow2] = useState(false);
  const [show0, setShow0] = useState(false);

  useEffect(() => {
    const { code, password, confirmPassword } = formValues || {};
    if (!code || !password || confirmPassword !== password) {
      setDisabled(true);
    } else {
      setDisabled(false);
    }
  }, [formValues]);

  // const inputStyle = {
  //   bg: "#fff",
  //   color: "#000",
  //   _placeholder: { color: "#000" },
  // };

  const change = (e) => {
    const { name, value } = e.target || {};
    setFormValues((prev) => ({ ...prev, [name]: value }));
  };

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const { code, password, confirmPassword } = formValues || {};

    const payload = {
      code: code,
      email: state?.email,
      password,
      password_confirmation: confirmPassword,
    };

    resetPassword(payload)
      .then((e) => {
        dispatch({
          signin: true,
          forgotPassword: false,
          resetPassword: false,
        });
        successNotifier("Password reset successful, please login");
         navigate('/login')
      })
      .catch((e) => {})
      .finally(() => {

setLoading(false)});
  };
  return (
    <Center
      backgroundImage={splash}
      h={{
        base: "100vh",
        sm: "100vh",
        md: "100vh",
        lg: "100vh",
        xl: "100vh",
        "2xl": "100vh",
      }}
    >
      <Grid>
        <Box
          backgroundColor={"#020B19"}
          mb={{ base: "0", sm: "0", md: "0", lg: "0", xl: "0", "2xl": "0" }}
          mt={{
            base: "2em",
            sm: "2em",
            md: "2em",
            lg: "2em",
            xl: "2em",
            "2xl": "2em",
          }}
          h={{
            base: "90vh",
            sm: "85vh",
            md: "90vh",
            lg: "88vh",
            xl: "80vh",
            "2xl": "80vh",
          }}
          w={{
            base: "100vw",
            sm: "100vw",
            md: "60vw",
            lg: "60vw",
            xl: "60vw",
            "2xl": "60vw",
          }}
          borderWidth={1}
          borderColor={"#66666680"}
          borderRadius={{
            base: "0",
            sm: "0",
            md: "24px",
            lg: "24px",
            xl: "24px",
            "2xl": "24px",
          }}
          boxShadow="lg"
          p={{
            base: "25px",
            sm: "15px",
            md: "40px",
            lg: "25px",
            xl: "25px",
            "2xl": "15px",
          }}
        >
          <Stack
            direction={{ base: "column", md: "row" }}
            mt={{
              base: "5em",
              sm: "5em",
              md: "2em",
              lg: "0em",
              xl: "0em",
              "2xl": "3em",
            }}
          >
            <Flex
              pt={"10%"}
              color={"white"}
              flex={1}
              align={"center"}
              justify={"center"}
              ml={"5px"}
            >
              <Stack spacing={4} w={"full"} maxW={"md"}>
                <Box>
                  <Link to="/register">
                    <Image
                      alt={"Login Image"}
                      marginBottom={"10px"}
                      width={"29px"}
                      src={arrow}
                      mt={"-50px"}
                    />
                  </Link>

                  <Heading
                    color={"#ffffff"}
                    paddingTop={1}
                    fontSize={"28px"}
                    fontWeight={500}
                    letterSpacing={0}
                    lineHeight={"normal"}
                  >
                    Reset Password
                  </Heading>
                  <Flex>
                    <Text
                      fontWeight={400}
                      fontFamily={("Poppins-Regular", "Helvetica")}
                      color={"white"}
                      fontSize={"15px"}
                      lineHeight={"normal"}
                      letterSpacing={0}
                    >
                      Reset your password
                    </Text>
                  </Flex>
                </Box>

                <Stack spacing={"20px"} color={textColor}>
                  <InputGroup size="md">
                    <Input
                      type="text"
                      placeholder="Enter code"
                      required
                      name="code"
                      color={"white"}
                      borderColor={"#66666680"}
                      variant={"outline"}
                      borderWidth={1}
                      backgroundColor={"#020B19"}
                      value={formValues?.code}
                      onChange={change}
                      autocomplete="off"
                    />
                    <InputRightElement width="4.5rem">
                      <FaRegTimesCircle
                        color="#677185"
                        onClick={() =>
                          setFormValues((prev) => ({ ...prev, email: "" }))
                        }
                        cursor="pointer"
                      />
                    </InputRightElement>
                  </InputGroup>

                  <InputGroup size="md">
                    <Input
                      color={"white"}
                      borderColor={"#66666680"}
                      variant={"outline"}
                      borderWidth={1}
                      backgroundColor={"#020B19"}
                      type={show ? "text" : "password"}
                      placeholder="New password"
                      required
                      name="password"
                      value={formValues?.password}
                      onChange={change}
                      autocomplete="off"
                    />
                    <InputRightElement width="4.5rem">
                      {show ? (
                        <BsEyeSlash
                          color="#677185"
                          onClick={() => setShow(!show)}
                          cursor="pointer"
                        />
                      ) : (
                        <BsEye
                          color="#677185"
                          onClick={() => setShow(!show)}
                          cursor="pointer"
                        />
                      )}
                    </InputRightElement>
                  </InputGroup>

                  <InputGroup size="md">
                    <Input
                      color={"white"}
                      borderColor={"#66666680"}
                      variant={"outline"}
                      borderWidth={1}
                      backgroundColor={"#020B19"}
                      type={show2 ? "text" : "password"}
                      placeholder="Confirm new password"
                      required
                      name="confirmPassword"
                      value={formValues?.confirmPassword}
                      onChange={change}
                      autocomplete="off"
                    />
                    <InputRightElement width="4.5rem">
                      {show2 ? (
                        <BsEyeSlash
                          color="#677185"
                          onClick={() => setShow2(!show2)}
                          cursor="pointer"
                        />
                      ) : (
                        <BsEye
                          color="#677185"
                          onClick={() => setShow2(!show2)}
                          cursor="pointer"
                        />
                      )}
                    </InputRightElement>
                  </InputGroup>


                </Stack>

                <Stack spacing={6}>
                  <Stack
                    direction={{ base: "column", sm: "row" }}
                    align={"start"}
                    justify={"space-between"}
                  ></Stack>

                  <Stack
                    align={{
                      base: "center",
                      sm: "center",
                      md: "end",
                      lg: "end",
                      xl: "end",
                      "2xl": "end",
                    }}
                  >
                    <Button
                      borderRadius={24}
                      bg={"#0076FF"}
                      w={"150px"}
                      type="submit"
                      onClick={submit}
                      isLoading={loading}
                      disabled={disabled}
                      
                      h={"50px"}
                      variant={"solid"}
                    >
                      {loading ? <Spinner /> : "Reset Password"}
                    </Button>
                  </Stack>
                </Stack>
              </Stack>
            </Flex>

            <Flex
              justify="center"
              align="center"
              display={["none", "none", "none", "flex"]}
            >
              <Image
                alt={"Login Image"}
                marginTop={6}
                height={"350px"}
                width={"250px"}
                objectFit={"cover"}
                src={logo}
              />
            </Flex>
          </Stack>
        </Box>
        <Flex mr={5} ml={5} justify={"space-between"}>
          <Box>
            <Select
              fontFamily={("Poppins-Regular", "Helvetica")}
              fontSize={".9em"}
              color={"white"}
              w="auto"
            >
              <option value="en"> English(Unites states)</option>
            </Select>
          </Box>
          <Box mt={2}>
            <Flex mr={10} justify={"space-evenly"}>
              <Text
                fontFamily={("Poppins-Regular", "Helvetica")}
                fontSize={12}
                color={"white"}
              >
                Help
              </Text>
              <Text
                fontFamily={("Poppins-Regular", "Helvetica")}
                fontSize={12}
                ml={"24px"}
                color={"white"}
              >
                Privacy
              </Text>
              <Text
                fontFamily={("Poppins-Regular", "Helvetica")}
                fontSize={12}
                ml={"24px"}
                color={"white"}
              >
                Terms
              </Text>
            </Flex>
          </Box>
        </Flex>
      </Grid>
    </Center>
  
  );
}

export default ResetPassword;
